<gc-button
  [variant]="'utility'"
  [size]="'small'"
  [icon]="'circleQuestion'"
  [iconPosition]="'left'"
  (clicked)="openFullSizeImageOverlay()"
>
  {{ 'reportInput.instructionImage' | translate }}
</gc-button>

@if (isShowingFullSizeImageOverlay()) {
  <app-full-size-image-overlay
    [srcUrl]="imgUrlByLanguage()"
    (closeOverlay)="closeFullSizeImageOverlay()"
  />
}
